var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
const getObjectStores = fetcher.path("/api/object_stores").method("get").create();
export function getSelectableObjectStores() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield getObjectStores({ selectable: true });
        return data;
    });
}
const getObjectStore = fetcher.path("/api/object_stores/{object_store_id}").method("get").create();
const getUserObjectStoreInstance = fetcher
    .path("/api/object_store_instances/{user_object_store_id}")
    .method("get")
    .create();
export function getObjectStoreDetails(id) {
    return __awaiter(this, void 0, void 0, function* () {
        if (id.startsWith("user_objects://")) {
            const userObjectStoreId = id.substring("user_objects://".length);
            const { data } = yield getUserObjectStoreInstance({ user_object_store_id: userObjectStoreId });
            return data;
        }
        else {
            const { data } = yield getObjectStore({ object_store_id: id });
            return data;
        }
    });
}
const updateObjectStoreFetcher = fetcher.path("/api/datasets/{dataset_id}/object_store_id").method("put").create();
export function updateObjectStore(datasetId, objectStoreId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield updateObjectStoreFetcher({ dataset_id: datasetId, object_store_id: objectStoreId });
        return data;
    });
}
